export default {
  profileInfo: {}
};
